"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../theme");
var input_style_1 = require("./input.style");
exports.CSS = {
    container: 'c-MultiListInput',
    label: 'c-MultiListInput__label',
    button: 'c-MultiListInput__button',
    edit: 'c-MultiListInput__edit',
    colorIndicator: 'c-MultiListInput__colorIndicator'
};
exports.Style = (_a = {},
    _a[exports.CSS.container] = (_b = {
            display: 'flex',
            flex: 1,
            'align-items': 'center',
            'justify-content': 'space-between'
        },
        _b["& .".concat(input_style_1.CSS.container)] = {
            cursor: 'pointer'
        },
        _b),
    _a[exports.CSS.button] = {
        flex: 1,
        display: 'flex',
        'font-family': theme_1.DefaultTheme.font.familyCondensed,
        'font-size': theme_1.DefaultTheme.font.size,
        height: theme_1.DefaultTheme.space(5),
        'line-height': theme_1.DefaultTheme.space(5),
        'align-items': 'center',
        'justify-content': 'space-between',
        'text-align': 'left',
        padding: 0,
        color: 'inherit',
        'font-weight': 'normal',
        'text-transform': 'none'
    },
    _a[exports.CSS.label] = {
        overflow: 'hidden',
        flex: 1,
        'text-overflow': 'ellipsis'
    },
    _a[exports.CSS.edit] = {
        transform: 'rotate(-90deg)',
        'font-size': 'inherit',
        color: theme_1.DefaultTheme.font.color.divider
    },
    _a[exports.CSS.colorIndicator] = {
        width: theme_1.DefaultTheme.space(3),
        height: theme_1.DefaultTheme.space(3),
        'border-radius': '50%',
        marginRight: theme_1.DefaultTheme.space(2)
    },
    _a);
//# sourceMappingURL=nested.list.input.style.js.map